import React from 'react'
import { useUserDocuments } from '@features/userDocuments'
import { Button } from '@shared/components/button'
import cx from 'classnames'

import { BrokerSignContentWrapper } from '../../../shared/broker/content-wrapper'

import DocumentIcon from './doc-icon.svg'
import { ViewProps } from './model'

import styles from './style.module.scss'

export const View = ({ documents, brokerName, onNextButtonClick }: ViewProps) => {
	const { getPdfDataUri } = useUserDocuments()!

	return (
		<BrokerSignContentWrapper title='Подпишите документы'>
			{brokerName} отправил вам на подпись документы:
			<div className={styles.docs}>
				{documents.map((document) => {
					const documentDataUri = getPdfDataUri(document.id)
					return (
						<a
							tabIndex={0}
							target='_blank'
							rel='noopener noreferrer nofollow'
							href={documentDataUri}
							className={cx(styles.docItem, !documentDataUri && styles.disabled)}
							key={document.id}
						>
							{!documentDataUri && <div className={styles.docLoader} />}
							<DocumentIcon />
							<div className={styles.docName}>{document.name}</div>
						</a>
					)
				})}
			</div>
			<div className={styles.buttonWrapper} onClick={onNextButtonClick}>
				<Button>Далее</Button>
			</div>
		</BrokerSignContentWrapper>
	)
}
